function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import L from 'leaflet';
import { Map, TileLayer } from 'react-leaflet';
import { useWorkFlow } from "../../../../contexts/workflow";
import useMap from "../use-map";
var positionDefault = [48.8534, 2.3488];
/**
 * Complex type
 *
 * @param {*} props
 */
var AddressMap = function AddressMap() {
  // hooks
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useMap = useMap(),
    zoom = _useMap.zoom,
    center = _useMap.center,
    baseMap = _useMap.baseMap;

  // STATE
  var _useState = useState(center || positionDefault),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useState3 = useState(15),
    _useState4 = _slicedToArray(_useState3, 2),
    setLeafletMap = _useState4[1];
  var mapRef = useRef();
  var initializePosition = function initializePosition() {
    var community = collector.diag ? collector.diag.community : {
      polygon: null,
      polygonColor: null
    };
    var polygon = community.polygon,
      polygonColor = community.polygonColor,
      coordinate = community.coordinate;
    var currentPosition = coordinate ? [coordinate[1], coordinate[0]] : positionDefault;
    if (polygon && mapRef && mapRef.current) {
      var leafletElement = mapRef.current.leafletElement;
      if (typeof polygon === 'string') {
        polygon = JSON.parse(polygon);
      }
      var polygonLeaflet = L.polygon(polygon, {
        color: polygonColor || '#0d9fdb'
      }).addTo(leafletElement);
      leafletElement.fitBounds(polygonLeaflet.getBounds());
    }
    setPosition(center || currentPosition);
  };
  useEffect(function () {
    if (!collector || !collector.diag || !collector.diag.community || !mapRef) {
      return;
    }
    initializePosition();
  }, [mapRef]);
  return /*#__PURE__*/React.createElement(Row, {
    className: "flex-column-reverse flex-sm-row pb-2",
    style: {
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 12,
      offset: -12
    },
    md: {
      size: 6
    }
  }, /*#__PURE__*/React.createElement(Map, {
    className: "collectorMapContainer",
    zoom: zoom || 10,
    center: position,
    whenCreated: setLeafletMap,
    ref: mapRef
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: "wever",
    url: baseMap
  }))));
};
AddressMap.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
AddressMap.defaultProps = {
  elements: []
};
export default AddressMap;